import Base from './Base'

export default class Question extends Base {
    type = 'question';
    min = 1;
    max = 1;
  
    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'type', 'parent', 'position', 'name', 'description', 'items', 'min', 'max', 'new', 'delete', 'show'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}